import { LitElement, html, css } from "lit-element";
import { customElement, property } from "lit/decorators.js";

@customElement("custom-toast")
export class CustomToast extends LitElement {
  @property({ type: Boolean }) isOpen = false; // Controls toast visibility
  @property({ type: String }) message = ""; // Message to display in the toast
  @property({ type: String }) position = "top-right"; // Position of the toast
  @property({ type: String }) type = "normal"; // Type of toast ("error", "danger", "normal", "success")

  // Open the toast and auto-dismiss after a few seconds
  openToast(message, position = "top-right", duration = 3000, type = "normal") {
    this.isOpen = true;
    this.message = message;
    this.position = position;
    this.type = type;

    setTimeout(() => {
      this.isOpen = false;
    }, duration);
  }

  protected createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div
        class="toast-container ${this.position} ${this.isOpen ? "" : "fade-out"}"
      >
        <div class="toast ${this.type}">
          <div class="icon">${this.getIcon()}</div>
          <span>${this.message}</span>
        </div>
      </div>
    `;
  }

  // Method to return an icon based on the toast type
  private getIcon() {
    switch (this.type) {
      case "error":
        return "❌";
      case "danger":
        return "⚠️";
      case "success":
        return "✅";
      default:
        return "ℹ️";
    }
  }

  static styles = css`
    .toast-container {
      position: fixed;
      z-index: 9999;
      transition: opacity 0.5s ease;
    }

    .top-right {
      top: 10px;
      right: 10px;
    }

    .toast {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: 5px;
      font-family: Arial, sans-serif;
      font-size: 14px;
      color: white;
      opacity: 1;
      transition: opacity 0.3s ease-in-out;
    }

    .fade-out {
      opacity: 0;
    }

    .toast .icon {
      margin-right: 8px;
    }

    /* Style for normal state */
    .toast.normal {
      background-color: #2196F3; /* Blue */
    }

    /* Style for success state */
    .toast.success {
      background-color: #4CAF50; /* Green */
    }

    /* Style for danger state */
    .toast.danger {
      background-color: #f44336; /* Red */
    }

    /* Style for error state */
    .toast.error {
      background-color: #ff9800; /* Orange */
    }
  `;
}
